<template>
  <div class="inventory-create" v-loading="loading">
    <LayoutStorage @btnBack="getBtnBack">
      <template v-slot:actions>
        <div class="d-flex flex-row">
          <el-button type="primary" v-if="reCreate" :loading="loading" @click="btnReCreate()">
            Đặt lại đơn
          </el-button>
          <el-button v-else type="primary" :disabled="!documentInfo.id" :loading="loading" @click="btnUpdateStorageOrder()">
            Hoàn tất
          </el-button>
        </div>
      </template>
      <template v-slot:title>
        <span v-if="documentID && !reCreate">
          Cập nhật đơn: {{ documentInfo.orderNo }}
        </span>
        <span v-else>
          Đặt lại đơn: {{ documentInfo.orderNoOld }}
        </span>
      </template>
      <template v-slot:content>
        <el-card>
          <div slot="header" class="card-header-ui">
            <span>Thông tin cơ bản</span>
          </div>
          <el-form ref="documentInfo" class="form" :model="documentInfo" :rules="documentInfoRule" label-width="140px">
            <el-row :gutter="10">
              <el-col :lg="12">
                <el-form-item label="Mã đơn" prop="orderNo">
                  <el-input v-model="documentInfo.orderNo" class="is-invalid" placeholder="Nhập mã đơn" style="width: 100%" />
                </el-form-item>
              </el-col>
              <el-col :lg="12" v-if="!reCreate">
                <el-form-item label="Thời gian nhập" prop="CreatedAt">
                  <el-date-picker
                    disabled
                    v-model="documentInfo.createdAt"
                    type="date"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="Chọn thời gian nhập">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :lg="16">
                <el-form-item label="Lý do nhập" prop="reason">
                  <el-input v-model="documentInfo.reason" class="is-invalid" placeholder="Lý do nhập" style="width: 100%" />
                </el-form-item>
                <el-form-item label="Ghi chú" prop="note">
                  <el-input v-model="documentInfo.note" type="textarea" :autosize="{ minRows: 2, maxRows: 10}" maxlength="255" placeholder="Ghi chú" style="width: 100%;" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
        <el-card style="margin: 20px 0;">
          <div slot="header" class="card-header-ui">
            <span>Nhà cung cấp</span>
          </div>
          <el-form :model="manufacoryInfo" ref="manufacoryInfo" :rules="manufacoryInfoRule" label-width="140px">
            <el-row>
              <el-col :lg="16">
                <el-form-item label="Nhà cung cấp" prop="name">
                  <el-select v-model="manufacoryInfo.name" @change="handleChange(manufacoryInfo)" placeholder="Lựa chọn nhà cung cấp" filterable>
                    <template slot="empty" v-if="manufacorys.length === 0">
                      <ModalAddSupplierFast type="text" text="Thêm nhanh nhà cung cấp" @response="getResponseSupplier" style="padding: 15px; cursor: pointer;"></ModalAddSupplierFast>
                    </template>
                    <template>
                      <ModalAddSupplierFast type="text" text="Thêm nhanh nhà cung cấp" @response="getResponseSupplier" style="padding: 15px; cursor: pointer;"></ModalAddSupplierFast>
                    </template>
                    <el-option v-for="(manufacory, index) in manufacorys" :key="index" :label="manufacory.name" :value="manufacory.value" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :lg="12">
                <el-form-item label="Email" prop="email">
                  <strong>
                    {{ manufacory.email }}
                  </strong>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item label="Số điện thoại" prop="phoneNumber">
                  <strong>
                    {{ manufacory.phoneNo }}
                  </strong>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item label="Địa chỉ" prop="address">
                <strong>
                  {{ manufacory.address }}
                </strong>
              </el-form-item>
            </el-row>
          </el-form>
        </el-card>
        <el-card>
          <div slot="header" class="card-header-ui">
            <span>Danh sách sản phẩm</span>
          </div>
          <div style="padding-bottom: 10px;">
            <el-form label-width="140px">
              <el-row :gutter="10">
                <el-col :lg="12">
                  <el-form-item label="Chi nhánh" prop="branch">
                    <el-select v-model="locationId" placeholder="Hãy lựa chọn chi nhánh">
                      <el-option v-for="(location, index) in locations" :key="index" :label="location.name" :value="location.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :lg="12">
                  <el-form-item label="Kho" prop="storage">
                    <el-select v-model="storageInfo" placeholder="Hãy lựa chọn kho">
                      <el-option v-for="(storage, index) in storagesDisplay" :key="index" :label="storage.name" :value="storage" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-select
                v-model="productChoose"
                filterable
                placeholder="Tìm kiếm"
              >
                <template slot="empty" v-if="variations.length === 0">
                  <ModalAddItemFast type="text" text="Thêm nhanh sản phẩm" @response="getResponse" style="padding: 15px; cursor: pointer;"></ModalAddItemFast>
                </template>
                <template name="empty">
                  <ModalAddItemFast type="text" text="Thêm nhanh sản phẩm" @response="getResponse" style="padding: 15px; cursor: pointer;"></ModalAddItemFast>
                </template>
                <el-option
                  v-for="(variation, index) in variations"
                  :key="index"
                  :label="variation.itemInstanceName"
                  :value="variation">
                </el-option>
              </el-select>
            </el-form>
          </div>
          <b-table :items="products" :fields="fields" show-empty class="is-valid-products">
            <template #empty>
              <div class="emptyTable">
                <IconBoxEmpty /> 
                <p>Chưa có sản phẩm nào được chọn.</p>
              </div>
            </template>
            <template #cell(itemInstanceName)="row">
              {{ row.item.itemInstance.moreInformation.name ? row.item.itemInstance.moreInformation.name : row.item.itemInstanceName }}
            </template>
            <template #cell(action)="row">
              <i class="el-icon-close pointer" @click="delLine(row)" />
            </template>
            <template #cell(unitPrice)="row">
              <input
                type="text"
                class="form-control"
                v-model="row.item.unitPrice"
                placeholder="Nhập giá"
                @keydown="allowNumbersOnly"
                @input="
                  row.item.unitPrice = formatMoney(
                    row.item.unitPrice
                  ),
                  setTotalAmount()
                "
              />
            </template>
            <template #cell(quantity)="row">
              <span v-if="row.item.useImeiAndSerial">{{ row.item.seriesNo.length }}</span>
              <span v-if="row.item.useProductBatch">{{ row.item.quantity }}</span>
              <b-form @submit.stop.prevent v-if="!row.item.useImeiAndSerial && !row.item.useProductBatch">
                <b-form-input
                  @keydown="allowNumbersOnly"
                  @input="setTotalAmount(), setValidate(row.item)"
                  v-model.trim="row.item.quantity"
                  placeholder="Nhập số lượng"
                  :state="row.item.validQuantity" id="feedback-user"
                  style="height: 40px;"
                ></b-form-input>
                <b-form-invalid-feedback :state="validQuantity">
                  {{ textValidationQuantity }}
                </b-form-invalid-feedback>
              </b-form>
            </template>
            <template #cell(total)="row">
              {{ ( removeDot(row.item.unitPrice) * (row.item.seriesNo.length > 0 ? row.item.seriesNo.length : row.item.quantity)).toLocaleString() }}
            </template>
            <template #row-details="row" @click="lineInfo = row.item">
              <div v-if="row.item.seriesNo.length > 0">
                <el-tag v-for="(seria, index) in row.item.seriesNo" :key="index" closable @close="handleCloseSeria(seria, row.item)" class="tag">
                  {{ seria.text }}
                </el-tag>
                <div class="d-flex flex-row" style="padding-top: 10px;">
                  <label style="padding-right: 10px; padding-top: 8px; font-weight: bold !important;">Seria/Imei</label>
                  <b-form style="width: 30%;">
                    <b-form-input
                      v-model.trim="row.item.serieNew"
                      placeholder="Nhập seria/imei"
                      :state="row.item.valid" id="feedback-user"
                      @keyup.native.enter="btnAddSeria(row.item)"
                      style="height: 40px;"
                      @input="handleInputSerial(row.item)"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="validationSeria">
                      {{ textValidationSeria }}
                    </b-form-invalid-feedback>
                  </b-form>
                  <el-button type="primary" size="small" style="height: 40px;" :loading="row.item.btnLoading" @click="btnAddSeria(row.item)" plain>Thêm</el-button>
                </div>
              </div>
              <div v-if="row.item.useProductBatch">
                <div>
                  <div style="padding-bottom: 20px;">
                    <base-tag v-for="(batch, index) in row.item.batchSelect" :key="index" type="info" closeTag :value="batch" @close="handleCloseExp(batch, row.item)" style="margin-right: 5px; margin-top: 8px;">
                      {{ batch.BATCH_CODE || batch.batchCode }} - HSD: {{ timeFormatDate(batch.EXPIRATION_DATE || batch.expirationDate) }} - SL: {{ batch.quantityChoose }}
                    </base-tag>
                  </div>
                  <div style="display: flex;">
                    <b style="padding-right: 20px; align-self: center;">Số lô:</b>
                    <popup-select-expried :item="row.item" :selected="row.item.batchSelect" @batchSelect="onBatchSelect" style="margin-right: 10px;" />
                    <popup-add-expried :item="row.item" :selected="row.item.batchSelect" @batchs="onBatchs" />
                  </div>
                </div>
              </div>
            </template>
          </b-table>
          <div class="d-flex justify-content-end pt-5 total-amount">
            <span>Tổng tiền: {{ totalAmount.toLocaleString() }} đ</span>
          </div>
        </el-card>
      </template>
    </LayoutStorage>
  </div>
</template>

<script>
import IconBoxEmpty from "@/components/icons/icon_box_empty.vue"
import { StorageService } from '@/services/nextshop/storage.service.js'
import { SupplierServices } from "@/services/nextshop/supplier.service"
import LayoutStorage from '@/router/layouts/storage.vue'
import { getLocationID, getMerchanIDCurrent, getPhoneNumber, getRuleUser, getUserId, getUserName } from '../../utils/auth'
import getListLocation from "@/mixins/location/getListLocation"
import { InventoryService } from '../../services/nextshop/inventory.service'
import Swal from 'sweetalert2'
import { formatTimeISO } from '../../utils/format'
import { API_STORAGE_CHECKIN, API_STORAGE_DETAIL, API_STORAGE_RECREATE } from '../../utils/contants'
import { formatMoney, transferBatch } from '../../utils/mapping'
import { ProductService } from "@/services/nextshop/product.service";
import { validInvenCode, validSeria } from '../../utils/validate'
import checkSerialItem from "@/mixins/storage/checkSerialItem";
import handlerReqCreatItem from "@/mixins/orders/reqAddItem";
import getListUnit from "@/mixins/items/getListUnit";
import getListCategory from "@/mixins/items/getListCategory";
import { CategoryService } from '../../services/nextshop/category.service'
import { checkSerialExist } from '@/mixins/storage/checkSerial.js'
import ModalAddItemFast from '@/pages/items/modal-add-item.vue';
import ModalAddSupplierFast from '@/pages/suppliers/modal-add-supplier.vue';
import PopupSelectExpried from "@/components/popup-add-quick/popup-select-expried.vue"
import PopupAddExpried from "@/components/popup-add-quick/popup-add-expried.vue"

export default {
  components: {
    LayoutStorage,
    IconBoxEmpty,
    ModalAddItemFast,
    ModalAddSupplierFast,
    PopupSelectExpried,
    PopupAddExpried
  },
  data() {
    let validOrderNo = (rule, value, callback) => {
      if (!validInvenCode(this.documentInfo.orderNo)) {
        return callback(new Error('Vui lòng nhập mã đơn không chứa ký tự đặc biệt'))
      } else {
        return callback()
      }
    }
    return {
      textValidationSeria: '',
      textValidationQuantity: '',
      textValidSKU: '',
      validSKU: null,
      validQuantity: null,
      validationSeria: null,
      fields: [
        { key: 'key', label: 'STT' },
        { key: 'itemInstanceName', label: 'Tên phiên bản', thStyle: { width: "40%", "min-width": "120px", "word-break": "break-word" }},
        { key: 'unitPrice', label: 'Giá nhập', thStyle: { width: "30%", "min-width": "120px" }},
        { key: 'quantity', label: 'Số lượng', thStyle: { width: "15%", "min-width": "120px" }},
        { key: 'total', label: 'Thành tiền', thStyle: { width: "20%", "min-width": "120px" }},
        { key: 'action', label: ''}
      ],
      btnLoading: false,
      visibleManufactory: false,
      visibleAddProduct: false,
      loading: false,
      documentID: this.$route.params.documentID,
      documentInfo: {
        createdAt: new Date(),
      },
      documentInfoRule: {
        orderNo: [
          { required: false, message: 'Không được để trống', trigger: 'change' },
          { validator: validOrderNo, trigger: 'change' }
        ],
        reason: [{ required: true, message: 'Không được để trống', trigger: 'change' }]
      },
      manufacoryInfoRule: {
        name: [{ required: false, message: 'Không được để trống', trigger: 'change' }]
      },
      groups: [],
      persons: [
        { value: true, label: "Cá nhân" },
        { value: false, label: "Doanh nghiệp" },
      ],
      manufacoryAddInfo: {
        person: false
      },
      manufacoryAddInfoRules: {
        name: [{ required: true, message: 'Không được để trống' }],
        phoneNo: [
          { message: 'Số điện thoại không đúng', max: 12, trigger: 'blur' },
          { required: true, message: 'Không được để trống'}
        ],
        email: [{ type: 'email', message: 'Định dạng email không đúng', trigger: 'blur' }]
      },
      manufacoryInfo: {},
      manufacory: {},
      products: [],
      productChoose: {},
      locations: [],
      locationInfo: {},
      locationId: '',
      validCode: false,
      manufacorys: [],
      storages: [],
      storagesDisplay: [],
      storageInfo: {},
      txtSearch: '',
      itemSelected: [],
      seriaNew: '',
      lineInfo: {},
      totalAmount: 0,
      // items
      paramItems: {
        queryString: '',
        merchantId: getMerchanIDCurrent(),
        pagingAndSorting: {
          limit: 100,
          lastIndex: "",
          sortOrder: "DESC",
        },
      },
      variations: [],
      allowAddSerie: [],
      units: [],
      categorys: [],
      types: [],
      loadingType: false
    }
  },
  mixins: [getListLocation, checkSerialItem, handlerReqCreatItem, getListUnit, getListCategory],
  watch: {
    products() {
      this.setTotalAmount()
    },
    async productChoose() {
      const checkExist = this.products.find(pro => pro.id === this.productChoose.id)
      if (checkExist) {
        this.$message.warning('Phiên bản đã tồn tại trong danh sách')
        return
      }
      this.products.push({...this.productChoose, batchSelect: [], type: 2, key: this.products.length + 1})
    },
    locationId() {
      const storageByLocation = this.locations.find(lo => lo.coLocationId === this.locationId)
      if (storageByLocation) {
        const storages = storageByLocation.inventories.map(inven => {
          return {
            ...inven,
            value: inven.coInventoryId
          }
        })
        this.storagesDisplay = storages
        this.storageInfo = storages[0]
      }
    },
    documentInfo() {
      if (this.reCreate) {
        this.documentInfo.orderNoOld = this.documentInfo.orderNo
        this.documentInfo.orderNo = ''
        this.documentInfo.processorStatus = ''
      }
    }
  },
  computed: {
    reCreate() {
      const getPath = this.$route.fullPath
      return getPath.includes(API_STORAGE_RECREATE)
    }
  },
  async created() {
    this.loading = true
    await this.checkConfigInventory()
    this.getGroupSupp()
    this.getSuppliers()
    this.getStorageByMerchant()
    this.getListVariation(this.paramItems)
    const locations = await this.getListLocation()
    this.locations = locations.filter(lo => {
      if (getRuleUser() === 'owner') {
        return true
      } else {
        return lo.coLocationId === getLocationID()
      }
    }).map(mer => {
      return {
        ...mer,
        value: mer.coLocationId
      }
    })
    if (this.documentID) {
      this.getDocumentInfo()
    }
  },
  methods: {
    handleCloseExp(val, item) {
      const batchIndex = item.batchSelect.findIndex(batch => batch.value === val.value)
      if (batchIndex !== -1) {
        item.batchSelect.splice(batchIndex, 1);
        this.setTotalAmount()
      }
    },
    onBatchs(obj) {
      const item = obj.item
      const batchs = obj.batchs.map(batch => {
        return {
          ...batch,
          quantityChoose: batch.quantity,
          value: batch.batchCode
        }
      })
      const findItem = this.products.find(product => product.variationId === item.variationId)
      if (findItem) {
        findItem.batchSelect.push(...batchs)
        findItem.quantity = findItem.batchSelect.reduce((a, b) => {
          return a + Number(b.quantityChoose)
        }, 0)
      }
      this.setTotalAmount()
    },
    onBatchSelect(obj) {
      const item = obj.item
      const batchs = obj.batchs
      const findItem = this.products.find(product => product.variationId === item.variationId)
      if (findItem) {
        findItem.batchSelect = batchs
        findItem.quantity = findItem.batchSelect.reduce((a, b) => {
          return a + Number(b.quantityChoose)
        }, 0)
      }
      this.setTotalAmount()
    },
    handleInputSerial(obj) {
      if (!obj.serieNew) {
        obj.valid = null
      }
    },
    getResponseSupplier(obj) {
      if (obj.id) {
        this.manufacorys.push({...obj, value: obj.id})
        const {name, id} = obj
        this.manufacoryInfo = {
          name: name,
          value: id
        }
        this.manufacory = obj
      }
    },
    getResponse(obj) {
      if (obj.item) {
        const { id, name, sku, unit } = obj.item
        const { price } = obj.itemPrice
        // chọn sp vừa thêm
        const priceExport = price.find(p => p.priceTypeCode === 'PRICE_EXPORT')
        const productNew = {
          id: obj.item.variations[0].itemVariationId, //id phiên bản
          addedAmount: [],
          amount: 0,
          discount: [],
          // itemInstance: {},
          itemInstanceName: obj.item.variations[0].name,
          itemName: name,
          lineItemId: id,
          value: id,
          lineItemOtherInfo: {
            inventoryId: this.storageInfo.value
          },
          note: '',
          quantity: 1,
          serieNew: '',
          seriesNo: [],
          tax: [],
          totalAmount: 0,
          unit: unit.name ? unit.name : 'Cái',
          unitPrice: priceExport ? (priceExport.amount/1000).toLocaleString() : 0,
          sku: sku,
          useImeiAndSerial: false,
          _showDetails: false,
          btnLoading: false,
          //validate input serial, quantity
          valid: null,
          validQuantity: null
        }
        const productInfoNew = {
          key: this.products.length + 1,
          ...productNew,
          itemInstance: {
            ...productNew,
            itemId: id,
            prices: price,
            quantity: 1,
            unit: {
              name: unit.name ? unit.name : 'Cái',
              additionalUnits: []
            }
          }
        }
        this.products.push(productInfoNew)
        this.variations.unshift(productInfoNew)
      }
      this.isPopupAddItem = false
    },
    async handleChangeCategory() {
      const params = {
        queryString: { parentId: { eq: this.productInfo.category } },
        sort: "-id",
        lastItem: "",
        limit: 100,
      }
      this.loadingType = true
      CategoryService.getList(params).then(res => {
        this.loadingType = false
        if (res.success) {
          this.types = res.data.map(type => {
            return {
              value: type.id,
              label: type.name
            }
          })
        }
      })
    },
    async getGroupSupp() {
      await SupplierServices.getGroupSupplier({
        merchantId: getMerchanIDCurrent()
      }).then(res => {
        if (res.success) {
          this.groups = res.data.map(gr => {
            return {
              ...gr,
              value: gr.id
            }
          })
        }
      })
    },
    btnReCreate() {
      // Đặt lại đơn hàng
      // this.loading = true
      const checkOrderNo = validInvenCode(this.documentInfo.orderNo)

      const handleParam = {
        orderNo: this.documentInfo.orderNo,
        locationId: this.locationId,
        inventoryId: this.storageInfo.value,
        inventoryName: this.storageInfo.label,
        currency: "VND",
        furtherInstructions: [
          {
            key: "CHECK_IN",
            cat: "INVENTORY_OPERATION",
            note: this.documentInfo.note,
            params: {
              employeeId: getUserId(),
              employeeName: getUserName(),
              employeePhone: getPhoneNumber(),
              reason: this.documentInfo.reason,
              note: this.documentInfo.note,
              referenceCode: "mã tham chiếu",
            },
          },
        ],
        note: "",
        lineItem: [],
        partyA: {},
        partyB: this.manufacoryInfo,
      }
      console.log(checkOrderNo);
    },
    async handleChange(obj) {
      const req = {
        merchantId: getMerchanIDCurrent(),
        person: 2,
        query: '',
        sort: 'date'
      }
      this.loading = true
      const supps = await SupplierServices.getListSupplier(req)
      this.loading = false
      if (supps.success) {
        const result = supps.data.find(manu => manu.id === obj.name)
        this.manufacory = result
      }
    },
    delLine(obj) {
      this.$confirm(`Bạn có thực sự muốn xóa phiên bản ${obj.item.itemInstanceName}`, 'Thông báo', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Đóng',
        type: 'warning'
      }).then(() => {
        this.products.splice(obj.index, 1)
      })
    },
    formatMoney(val) {
      const result = formatMoney(val)
      return result
    },
    removeDot(val) {
      if (val) {
        return val.toString().split('.').join('')
      } else {
        return 0
      }
    },
    setValidate(obj) {
      if (obj.quantity == 0) {
        obj.validQuantity = false
        this.textValidationQuantity = 'Hãy nhập serial/imei'
      } else {
        obj.validQuantity = null
      }
    },
    setTotalAmount(val) {
      const arrs = val ? val : this.products
      const result = arrs.reduce((a, b) => {
        var quantity = b.seriesNo.length > 0 ? b.seriesNo.length : b.quantity
        return a + quantity * this.removeDot(b.unitPrice)
      }, 0)
      this.totalAmount = result
    },
    getBtnBack() {
      this.$router.push(API_STORAGE_CHECKIN)
      // this.$router.go(-1)
    },
    btnUpdateStorageOrder() {
      // kiểm tra sl các pb
      try {
        const checkQuantity = this.products.filter(product => (product.quantity == '0' && !product.useImeiAndSerial) || (product.seriesNo.length === 0 && product.useImeiAndSerial))
        if (checkQuantity.length > 0) {
          let el = document.querySelector(".is-valid-products");
          if (el) {
            this.loading = false;
            el.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
          return
        }
        const checkBatchCode = this.products.filter(product => product.useProductBatch && product.batchSelect.length === 0)
        if (checkBatchCode.length > 0) {
          let el = document.querySelector(".is-valid-products");
          if (el) {
            this.loading = false;
            el.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
          this.$notify({
            type: 'warning',
            title: 'Thông báo',
            message: 'Hãy chọn số lô - hạn sử dụng cho phiên bản'
          })
          return
        }
        //end
        
        let statusDoc = false
        this.$refs.documentInfo.validate((valid) => {
          statusDoc = valid
        })
        if (!statusDoc) {
          let el = document.querySelector(".is-invalid");
          if (el) {
            this.loading = false;
            el.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
          return
        }
        const lineItem = this.products.map(product => {
          var priceImport = product.itemInstance.prices.find(p => p.priceTypeCode === 'PRICE_IMPORT')
          if (product.useProductBatch) {
            return product.batchSelect.map(batch => {
              return {
                ...product,
                lineItemOtherInfo: {
                  inventoryId: this.storageInfo.value,
                  seriesNo: JSON.stringify([]),
                  BATCH_CODE: batch.value,
                  MANUFACTURE_DATE: batch.manufactureDate,
                  EXPIRATION_DATE: batch.expirationDate,
                  TYPE: 'NSH_ITEM_SALE',
                  INVENTORY_ID: this.storageInfo.value
                },
                quantity: batch.quantityChoose,
                itemInstance: {
                  ...product.itemInstance,
                  prices: [
                    ...product.itemInstance.prices.filter(p => p.priceTypeCode ==='PRICE_EXPORT'),
                    {
                      ...priceImport,
                      amount: parseInt(this.removeDot(product.unitPrice)) * 1000,
                    }
                  ]
                },
                unitPrice: parseInt(this.removeDot(product.unitPrice)) * 1000,
                name: product.itemName,
                totalAmount: parseInt(this.removeDot(product.unitPrice)) * 1000 * Number(batch.quantityChoose),
                amount: parseInt(this.removeDot(product.unitPrice)) * 1000 * Number(batch.quantityChoose)
              }
            })
          } else {
            return {
              ...product,
              lineItemOtherInfo: {
                inventoryId: this.storageInfo.value,
                seriesNo: product.seriesNo.length > 0 ? JSON.stringify(product.seriesNo.map(serie => serie.text)) : ''
              },
              quantity: product.useImeiAndSerial ? product.seriesNo.length : product.quantity,
              itemInstance: {
                ...product.itemInstance,
                prices: [
                  ...product.itemInstance.prices.filter(p => p.priceTypeCode ==='PRICE_EXPORT'),
                  {
                    ...priceImport,
                    amount: parseInt(this.removeDot(product.unitPrice)) * 1000,
                  }
                ]
              },
              unitPrice: parseInt(this.removeDot(product.unitPrice)) * 1000,
              name: product.itemName
            }
          }
        })
        const req = {
          id: this.documentID,
          locationId: this.locationId,
          orderNo: this.documentInfo.orderNo,
          furtherInstructions: [
            {
              key: 'CHECK_IN',
              cat: 'INVENTORY_OPERATION',
              note: '',
              params: {
                reason: this.documentInfo.reason,
                note: this.documentInfo.note,
                toInventoryId: this.storageInfo.value,
                toInventoryName: this.storageInfo.value,
                employeeId: getUserId(),
                employeeName: getUserName(),
                employeePhone: getPhoneNumber()
              },
            },
            {
              key: "FOR_PRODUCT_BATCH",
              cat: "FOR_PRODUCT_BATCH",
              note: "",
              params: {}
            }
          ],
          note: this.documentInfo.note,
          lineItem: lineItem.flat(),
          // thông tin merchant
          partyA: {
            title: this.locationInfo?.name,
            displayName: this.locationInfo?.name,
            resId: this.locationInfo?.id,
            role: 'BUYER',
            otherInfo: {}
          },
          // thông tin nhà cung cấp
          partyB: {
            ...this.manufacory,
            title: this.manufacory.name,
            displayName: this.manufacory.name,
            resId: this.manufacory.id,
            email: this.manufacory.email,
            role: 'SUPPLIER',
            source: 'CORE',
            resName: 'PARTNER',
            resCat: 'PARTNER',
            otherInfo: {
              email: this.manufacory.email
            }
          },
        }
        console.log(req);
        this.loading = true
        StorageService.storageUpdateOrder(req).then(res => {
          this.loading = false
          if (res.success) {
            Swal.fire({
              title: 'Thành công',
              text: 'Cập nhật thông tin đơn hàng thành công',
              icon: 'success',
              confirmButtonText: 'Xác nhận'
            }).then(() => {
              this.$router.push(`${API_STORAGE_DETAIL}/${res.data.id}`)
            })
          }
        })
      } catch (error) {
        console.log('update order', error)
      }
    },
    async btnAddSeria(obj) {
      const serials = this.products.map(product => product.seriesNo).flat()
      const checkSeria = serials.find(ser => ser.text.trim().toLowerCase() === obj.serieNew.trim().toLowerCase())
      if (!validSeria(obj.serieNew)) {
        obj.valid = false
        this.textValidationSeria = 'Độ dài của serial/imei là từ 3 - 25 ký tự, viết liền, không chứa ký tự đặc biệt trừ “-” và “_”'
        return
      } else if (checkSeria) {
        obj.valid= false
        this.textValidationSeria = 'Đã tồn tại serial/imei trong danh sách. Vui lòng nhập mã serial/imei khác!'
        return
      }
      obj.btnLoading = true
      checkSerialExist(obj.serieNew.trim()).then(async res => {
        obj.btnLoading = false
        const response = res.data
        if (response.length > 0) {
          obj.valid = false
          this.textValidationSeria = 'Đã tồn tại serial/imei trên hệ thống. Vui lòng nhập mã serial/imei khác!'
        } else {
          obj.seriesNo.push({ text: obj.serieNew, value: obj.seriesNo.length })
          obj.serieNew = ''
          obj.valid = null
          this.setTotalAmount()
        }
      })
    },
    handleCloseSeria(val, obj) {
      const checkIndex = obj.seriesNo.findIndex(serie => serie.value === val.value)
      if (checkIndex === -1) {
        this.$message.error('Seria/imei không tồn tại')
        return
      }
      obj.seriesNo.splice(checkIndex, 1)
      const checkIndex2 = this.products.findIndex(product => product.itemInstance.itemVariationId === obj.itemInstance.itemVariationId)
      if (obj.seriesNo.length === 0) {
        this.products[checkIndex2].valid = false
        this.textValidationSeria = 'Hãy nhập serial/imei'
      }
    },
    async getDocumentInfo() {
      // lấy thông tin phiếu
      await StorageService.storageGetInfoOrderById({ id: this.documentID }).then(res => {
        this.loading = false
        if (res.success) {
          const { furtherInstructions, partyA, partyB, lineItem } = res.data
          const documentInfo = {
            ...res.data,
            note: furtherInstructions[0].params.note,
            reason: furtherInstructions[0].params.reason,
            createdAt: formatTimeISO(res.data.createdAt)
          }
          this.documentInfo = documentInfo
          this.manufacoryInfo = { ...partyB, name: partyB.displayName, value: partyB.resId, id: partyB.resId }
          this.manufacory = { ...partyB, name: partyB.displayName, value: partyB.resId, email: partyB.otherInfo?.email, id: partyB.resId }
          this.storageInfo = lineItem[0].lineItemOtherInfo.inventoryId
          const products = lineItem.map((line, index) => {
            const itemInstancePrice = line.itemInstance.prices.find(pri => pri.priceTypeCode === 'PRICE_IMPORT')
            const batch = line.lineItemOtherInfo.useProductBatch === "true"
            const serieNo = line.lineItemOtherInfo.seriesNo
            const series = serieNo ? JSON.parse(serieNo) : []
            return {
              ...line,
              id: line.itemInstance.itemVariationId,
              type: 1,
              key: index + 1,
              itemInstanceName: line.itemInstance.name,
              itemName: line.itemInstance.name,
              seriesNo: series.map((serie, index) => {
                return {
                  text: serie,
                  value: index + 1
                }
              }),
              unitPrice: formatMoney(itemInstancePrice?.amount / 1000),
              serieNew: '',
              value: index,
              sku: line.itemInstance.moreInformation.sku,
              useImeiAndSerial: series.length > 0,
              useProductBatch: batch,
              _showDetails: series.length > 0 || batch,
              btnLoading: false,
              valid: null
            }
          })
          this.products = transferBatch(products)
          this.setTotalAmount(transferBatch(products))
          // lấy thông tin chi nhánh và kho
          this.locationInfo = { name: partyA.displayName, value: res.data.locationToCreate }
          this.locationId = res.data.locationToCreate
          // this.storagesDisplay = this.storages.filter(st => st.coLocationId === res.data.locationToCreate)
          this.storageInfo = {value: furtherInstructions[0].params.toInventoryId, label: furtherInstructions[0].params.toInventoryName}
        }
      })
    },
    async getListVariation(param) {
      const response = await ProductService.getList(param);
      if (response.success) {
        response.data.map(i => {
          const priceImport = i.prices.find(p => p.priceTypeCode === 'PRICE_IMPORT')
          i.variations.map(variation => {
            const item = {
              ...variation,
              addedAmount: [],
              id: variation.variationId,
              amount: 0,
              discount: [],
              itemInstance: {...variation, itemId: variation.variationId, moreInformation: variation},
              itemInstanceName: variation.name,
              itemName: i.name,
              lineItemId: variation.variationId,
              value: variation.variationId,
              lineItemOtherInfo: {
                inventoryId: variation.stockQuantities.length > 0 ? variation.stockQuantities[0].inventoryId : ''
              },
              note: '',
              quantity: 1,
              serieNew: '',
              seriesNo: [],
              tax: [],
              totalAmount: 0,
              unit: i.unit.name,
              unitPrice: priceImport ? (priceImport.amount/1000).toLocaleString() : 0,
              sku: variation.sku,
              useImeiAndSerial: i.metaSearchable?.useImeiAndSerial === 'true',
              useProductBatch: i.metaSearchable?.useProductBatch === 'true',
              _showDetails: i.metaSearchable?.useImeiAndSerial === 'true' || i.metaSearchable?.useProductBatch === 'true',
              btnLoading: false,
              valid: null
            }
            this.variations.push(item)
          })
        })

        if (response.data.length > 99) {
          this.getListVariation({
            ...this.paramItems,
            pagingAndSorting: {
              ...this.paramItems.pagingAndSorting,
              lastIndex: response.data[99].itemId,
            },
          });
        }
      }
    },
    async getSuppliers() {
      const req = {
        merchantId: getMerchanIDCurrent(),
        person: 2,
        query: '',
        sort: 'date'
      }
      await SupplierServices.getListSupplier(req).then(res => {
        if (res.success) {
          this.manufacorys = res.data.map(manu => {
            return {
              ...manu,
              value: manu.id
            }
          })
        }
      })
    },
    getStorageByMerchant() {
      const req = {
        coLocationoId: getLocationID(),
        coMerchantId: getMerchanIDCurrent(),
        limit: 50,
        page: 1,
        textSearch: ''
      }
      InventoryService.inventorylist(req).then(res => {
        if (res.success) {
          this.storages = res.data.filter(i => i.isDefault).map(storage => {
            return {
              ...storage,
              value: storage.coInventoryId
            }
          })
        }
      })
    }
  }
}
</script>

<style>
.inventory-create .total-amount{
  font-size: 16px;
  font-weight: bold;
}
.inventory-create .el-input.is-disabled .el-input__inner {
  color: #111;
}
.inventory-create .el-card__header {
  border-bottom: none;
}
.inventory-create .el-select {
  width: 100%;
}
</style>
<style lang="scss" scoped>
.inventory-create {
  .emptyTable {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px 0px;

    p {
      margin: 10px 0px 0px 0px;
      color: #808890;
    }
  }
  .tag {
    margin: 0 3px;
  }
  .form-control:focus{
    border: 1px solid #409EFF;
  }
}
</style>